<mat-list-item class="igo-layer-list-item">
  <span
    matListItemTitle
    class="igo-layer-title"
    [matTooltip]="tooltipText"
    matTooltipShowDelay="500"
    >{{ layer().title }}</span
  >
</mat-list-item>

<div #legend class="igo-layer-legend-container">
  <igo-layer-legend
    [layer]="layer()"
    [updateLegendOnResolutionChange]="updateLegendOnResolutionChange()"
  />
</div>
